module.exports = __webpack_public_path__ + "static/img/how-get-credit-1.844caaf3.svg";